import type { MetricColumnConfig } from '../../../config/tpoGenConfig';
import type { PPGRow, TotalsRow } from '../../../types/promoMetrics';

/**
 * Aggregates a totals row from the current PPG rows.
 *
 * Additive metrics are summed; ratio/percentage metrics (postUnit `%`) are
 * averaged instead, since summing them would produce meaningless values (e.g.
 * 480%). Only top-level PPGs are aggregated — children already roll up into
 * their parent, so including them would double-count.
 *
 * NOTE: averaging percentages is an approximation. A true rollup needs a
 * volume/sales-weighted average; swap this out once the BE returns `totals`.
 */
export const computeTotals = (ppgs: PPGRow[], configs: MetricColumnConfig[]): TotalsRow => {
    const values: Record<string, number> = {};
    for (const config of configs) {
        const isRatio = config.postUnit.trim() === '%';
        let sum = 0;
        let count = 0;
        for (const ppg of ppgs) {
            const value = ppg.values[config.key];
            if (typeof value === 'number' && !Number.isNaN(value)) {
                sum += value;
                count += 1;
            }
        }
        values[config.key] = isRatio && count > 0 ? sum / count : sum;
    }
    return { values };
};
